module.exports = __webpack_public_path__ + "img/4H.2a998834.png";